import { render, staticRenderFns } from "./Progess.vue?vue&type=template&id=589cc2e0&"
import script from "./Progess.vue?vue&type=script&lang=js&"
export * from "./Progess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports